import {Language} from "./language/Language";
import {
	DateTimeFormatter,
	Instant,
	LocalDate,
	LocalDateTime,
	ZonedDateTime, ZoneId
} from "@js-joda/core";

export class Localization {
	constructor(
		readonly language: Language,
	) {
	}
	
	/**
	 * Formats the given date as string with the provided format
	 */
	formatDate(date: LocalDate, format: string): string {
		return DateTimeFormatter.ofPattern(format)
			.withLocale(this.language.locale)
			.format(date);
	}
	
	/**
	 * Formats the given date/time as string with the provided format
	 */
	formatDateTime(date: LocalDateTime | ZonedDateTime | Instant, format: string): string {
		if (date instanceof Instant)
			return this.formatDateTime(date.atZone(ZoneId.systemDefault()), format);
		if (date instanceof LocalDateTime)
			return this.formatDateTime(date.atZone(ZoneId.systemDefault()), format);
		
		return DateTimeFormatter.ofPattern(format)
			.withLocale(this.language.locale)
			.format(date);
	}
	
	// todo replace with datetimeformatter
	static formatDate(text: string | null | undefined): string {
		if (!text)
			return "";
		
		const tIndex = text.indexOf("T");
		
		if (tIndex > 0) {
			text = text.substring(0, tIndex);
		}
		
		const split = text.split("-");
		if (split.length === 3)
			text = split[2] + "-" + split[1] + "-" + split[0];
		
		return text;
	}
	
	static formatDateTime(text: string | null | undefined): string {
		if (!text)
			return "";
		
		const tIndex = text.indexOf("T");
		let time = "";
		if (tIndex > 0) {
			time = text.substring(tIndex + 1, text.length - 1);
			text = text.substring(0, tIndex);
		}
		
		const split = text.split("-");
		if (split.length === 3)
			text = split[2] + "-" + split[1] + "-" + split[0] + " " + time;
		
		return text;
	}
}
